import $ from 'jquery';
import Hamburger from './hamburger';

function init() {
	const prefix = 'header-catalogue';
	const $dropdown = $(`#${prefix}-dropdown`);;
	let toggle = new Hamburger(`#${prefix}-toggle`);
	const stateAttr = 'data-block-state';
	const states = {
		hidden: 'hidden',
		transition: 'transition',
		visible: 'visible'
	}
	const timeout = 300;

	function changeState(state) {
		$dropdown.attr(stateAttr, states[state]);
	}

	function show() {
		changeState('transition');
		setTimeout(() => {
			changeState('visible');
		}, timeout);
	}

	function hide() {
		changeState('transition');
		setTimeout(() => {
			changeState('hidden');
		}, timeout);
	}

	toggle.toggle(show, hide);
}

document.addEventListener('DOMContentLoaded', init);
